import { render, staticRenderFns } from "./PayStatus.vue?vue&type=template&id=1df4397d&scoped=true&"
import script from "./PayStatus.vue?vue&type=script&lang=js&"
export * from "./PayStatus.vue?vue&type=script&lang=js&"
import style0 from "./PayStatus.vue?vue&type=style&index=0&id=1df4397d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df4397d",
  null
  
)

export default component.exports